export const CHANGE_LNG = "CHANGE_LNG";
export const CHECK_EMAIL = "CHECK_EMAIL_SUCCESS";
export const BEGIN_API_CALL = 'BEGIN_API_CALL';
export const API_CALL_ERROR = 'API_CALL_ERROR';
export const GET_IP = 'GET_IP';